import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer/product/bundle'

const initialState = () => ({
    numbers: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        numbers: state => state.numbers.data,
        pagination: state => state.numbers.pagination
    },
    actions: {
        /**
         * @param {{customerId: number, bundleId: number, params: {}}} data
         * @returns {Promise<*>}
         */
        listNumbers: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listBundleNumbers(data)
                const numbers = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_BUNDLE_NUMBERS, numbers)
                return numbers
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetNumbers: ({commit}) => commit(mutationTypes.RESET_BUNDLE_NUMBERS)
    },
    mutations: {
        [mutationTypes.RESET_BUNDLE_NUMBERS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_BUNDLE_NUMBERS]: (state, data) => state.numbers = data
    }
}
